<template>
  <div class="admin" :class="{ 'admin--with-sidebar': isSidebarPresent }">
    <filters
      :filters="filters"
      :available-filters="availableFilters"
      @change="setFilters"
    />

    <br />

    <entity-table
      :columns="columns"
      :items="textContents"
      :are-items-clickable="true"
      :is-loaded="!!numberOfPages"
      :pagination="pagination"
      title="Tekstovni Sestavki"
      add-text="Nov Tekstovni Sestavek"
      :empty-text="emptyText"
      @search="setQuery"
      @page-change="goToPage"
      @click="openEditTextContent"
      @clickWithModifier="openEditTextContentInNewTab"
      @add="$router.push({ name: 'admin_new_text_content_path' })"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import EntityTable from '@/components/shared/EntityTable'
import Filters from '@/components/shared/Filters'
import PaginationMixin from '../../shared/PaginationMixin'

export default {
  components: { EntityTable, Filters },
  mixins: [PaginationMixin],
  beforeCreate () {
    this.columns = [
      { id: 'id', name: 'ID' },
      { id: 'name', name: 'Ime' },
      { id: 'keywords', name: 'Ključne besede' },
      { id: 'usage_in_documents', name: 'Uporabljen v dokumentih' },
    ]
  },
  created () {
    this.initialize()
    this.storeModule = ['admin', 'textContents']
  },
  beforeDestroy () {
    this.reset()
  },
  computed: {
    ...mapState('admin/textContents', ['textContents', 'numberOfPages', 'filters', 'query']),
    ...mapGetters('admin/textContents', ['availableFilters']),
    emptyText () {
      return this.query ? 'Noben sestavek ne ustreza iskanju.' : 'Zaenkrat še nimate sestavkov.'
    },
  },
  methods: {
    ...mapActions('admin/textContents', ['initialize', 'reset', 'setQuery', 'goToPage', 'setFilters']),
    openEditTextContent (textContent) {
      this.$router.push({
        name: 'admin_text_content_edit_path',
        params: {
          id: textContent.id,
        },
      })
    },
    openEditTextContentInNewTab (textContent) {
      const route = this.$router.resolve({
        name: 'admin_text_content_edit_path',
        params: {
          id: textContent.id,
        },
      })
      window.open(route.href, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/components/common';
@import '@/components/admin_common';
</style>
